var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"props":_vm.props,"placeholder":"小号可能在哪些城市直播"},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }